import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { ViewTitle } from '../components/reusable'

function PageNotFound() {
    return (
        <div className="home">
            <Sidebar />
            <MainView>
                <div>
                    <h1>Page Not Found</h1>
                </div>
            </MainView>
        </div>
    )
}

export default PageNotFound
